import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "pop_up applicant_chk com_pop",
  style: {"max-width":"1600px"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "date_wrap" }
const _hoisted_4 = {
  key: 0,
  class: "state_tag"
}
const _hoisted_5 = {
  key: 1,
  class: "state_tag waiting"
}
const _hoisted_6 = {
  key: 2,
  class: "state_tag finish"
}
const _hoisted_7 = { class: "end_point" }
const _hoisted_8 = {
  key: 3,
  class: "activity_duration"
}
const _hoisted_9 = {
  key: 0,
  class: "list_container _flex"
}
const _hoisted_10 = { class: "left" }
const _hoisted_11 = { class: "num_wrap" }
const _hoisted_12 = { class: "btn_area" }
const _hoisted_13 = {
  type: "button",
  class: "excel_btn icon_wrap"
}
const _hoisted_14 = { class: "common_table custom_scroll" }
const _hoisted_15 = { style: {"table-layout":"auto"} }
const _hoisted_16 = { style: {"min-width":"130px","width":"auto"} }
const _hoisted_17 = { style: {"white-space":"nowrap","padding":"5px 10px"} }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = {
  key: 1,
  class: "list_container _flex"
}
const _hoisted_22 = { class: "left" }
const _hoisted_23 = { class: "num_wrap" }
const _hoisted_24 = { class: "btn_area" }
const _hoisted_25 = {
  type: "button",
  class: "excel_btn icon_wrap"
}
const _hoisted_26 = { class: "common_table custom_scroll" }
const _hoisted_27 = {
  key: 0,
  style: {"width":"15px"}
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "_ph" }
const _hoisted_30 = {
  key: 0,
  class: "_ph"
}
const _hoisted_31 = {
  key: 1,
  class: "_ph"
}
const _hoisted_32 = {
  key: 2,
  class: "_ph"
}
const _hoisted_33 = {
  key: 3,
  class: "_ph"
}
const _hoisted_34 = {
  key: 4,
  class: "_ph"
}
const _hoisted_35 = {
  key: 5,
  class: "_ph"
}
const _hoisted_36 = {
  key: 6,
  class: "_ph"
}
const _hoisted_37 = { class: "checkbox_wrap cnt p_5 checkbox_wrap2" }
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = { class: "checkbox_wrap cnt p_5 checkbox_wrap2" }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = { class: "checkbox_wrap cnt p_5 checkbox_wrap2" }
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = ["onUpdate:modelValue"]
const _hoisted_49 = { key: 0 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  key: 0,
  class: "memo_wrap"
}
const _hoisted_53 = {
  key: 1,
  class: "step_content"
}
const _hoisted_54 = { class: "checkbox_wrap2" }
const _hoisted_55 = { class: "checkbox_wrap2" }
const _hoisted_56 = { class: "checkbox_wrap2" }
const _hoisted_57 = { class: "checkbox_wrap2" }
const _hoisted_58 = { class: "checkbox_wrap2" }
const _hoisted_59 = { class: "checkbox_wrap2" }
const _hoisted_60 = { class: "checkbox_wrap2" }
const _hoisted_61 = { class: "checkbox_wrap2" }
const _hoisted_62 = { class: "checkbox_wrap2" }
const _hoisted_63 = {
  key: 2,
  class: "_flex _center btn_wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_SpotTheDiff = _resolveComponent("SpotTheDiff")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString($setup.state.boardDetail.title), 1),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[28] || (_cache[28] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        ($setup.state.boardDetail.state == 2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "진행중"))
          : ($setup.state.boardDetail.state == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "대기중"))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, "마감")),
        _createElementVNode("div", _hoisted_7, [
          _cache[29] || (_cache[29] = _createElementVNode("span", null, [
            _createElementVNode("img", {
              src: "img/time_icon.png",
              alt: ""
            }),
            _createTextVNode(" 신청종료일 ")
          ], -1)),
          _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.boardDetail.applyDate), ".")), 1)
        ]),
        ($setup.state.boardDetail.activeStartDate && $setup.state.boardDetail.activeEndDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[30] || (_cache[30] = _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: "img/cal_icon.png",
                  alt: ""
                }),
                _createTextVNode(" 활동기간 ")
              ], -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.boardDetail.activeStartDate), ".")), 1),
              _cache[31] || (_cache[31] = _createElementVNode("em", null, "-", -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.state.boardDetail.activeEndDate), ".")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      ($setup.state.eventIdx !== $setup.props.idx)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[32] || (_cache[32] = _createElementVNode("span", null, "신청인원", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.totalLength)) + " 명", 1),
                  _createElementVNode("button", _hoisted_13, [
                    _createElementVNode("img", {
                      src: "img/excel_icon.png",
                      alt: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.downloadFile(0)))
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("colgroup", null, [
                    _cache[33] || (_cache[33] = _createElementVNode("col", { style: {"min-width":"70px"} }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.formList, (form) => {
                      return (_openBlock(), _createElementBlock("col", _hoisted_16))
                    }), 256)),
                    _cache[34] || (_cache[34] = _createElementVNode("col", { style: {"min-width":"100px"} }, null, -1))
                  ]),
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[35] || (_cache[35] = _createElementVNode("th", null, "번호", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.formList, (form) => {
                        return (_openBlock(), _createElementBlock("th", _hoisted_17, _toDisplayString(form.title), 1))
                      }), 256)),
                      _cache[36] || (_cache[36] = _createElementVNode("th", null, "신청일", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    ($setup.state.totalLength > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.applyList, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.idx
                          }, [
                            _createElementVNode("td", null, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.formList, (form) => {
                              return (_openBlock(), _createElementBlock("td", {
                                style: {"white-space":"pre-line","padding":"5px"},
                                innerHTML: $setup.answerFormat(form)
                              }, null, 8, _hoisted_18))
                            }), 256)),
                            _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.createDate), ".")), 1)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                          _createElementVNode("td", {
                            colspan: 2 + ($setup.state.formList.length > 0 ? $setup.state.formList.length : 0)
                          }, [...(_cache[37] || (_cache[37] = [
                            _createElementVNode("div", {
                              class: "tb_subject",
                              style: {"text-align":"center","width":"100%"}
                            }, "신청 인원이 없습니다.", -1)
                          ]))], 8, _hoisted_20)
                        ]))
                  ])
                ])
              ]),
              ($setup.state.totalLength > 0)
                ? (_openBlock(), _createBlock(_component_PageBtn, {
                    key: 0,
                    currentPage: $setup.state.page,
                    totalLength: $setup.state.totalLength,
                    perPage: $setup.state.size,
                    data: $setup.state.data,
                    onOnPaging: $setup.handlePageChange
                  }, null, 8, ["currentPage", "totalLength", "perPage", "data", "onOnPaging"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[38] || (_cache[38] = _createElementVNode("span", null, "신청인원", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.totalLength)) + " 명", 1),
                  _createElementVNode("button", _hoisted_25, [
                    _createElementVNode("img", {
                      src: "img/excel_icon.png",
                      alt: "",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.downloadFile(0)))
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("table", null, [
                  _createElementVNode("colgroup", null, [
                    _cache[39] || (_cache[39] = _createElementVNode("col", { style: {"width":"10px"} }, null, -1)),
                    _cache[40] || (_cache[40] = _createElementVNode("col", { style: {"width":"20px"} }, null, -1)),
                    _cache[41] || (_cache[41] = _createElementVNode("col", { style: {"width":"40px"} }, null, -1)),
                    _cache[42] || (_cache[42] = _createElementVNode("col", { style: {"width":"30px"} }, null, -1)),
                    _cache[43] || (_cache[43] = _createElementVNode("col", { style: {"width":"15px"} }, null, -1)),
                    _cache[44] || (_cache[44] = _createElementVNode("col", { style: {"width":"40px"} }, null, -1)),
                    _cache[45] || (_cache[45] = _createElementVNode("col", { style: {"width":"40px"} }, null, -1)),
                    _cache[46] || (_cache[46] = _createElementVNode("col", { style: {"width":"40px"} }, null, -1)),
                    _cache[47] || (_cache[47] = _createElementVNode("col", { style: {"width":"20px"} }, null, -1)),
                    ($setup.state.boardDetail.idx === $setup.state.eventIdx)
                      ? (_openBlock(), _createElementBlock("col", _hoisted_27))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[48] || (_cache[48] = _createElementVNode("th", null, "번호", -1)),
                      _cache[49] || (_cache[49] = _createElementVNode("th", null, "이름", -1)),
                      _cache[50] || (_cache[50] = _createElementVNode("th", null, "이메일", -1)),
                      _cache[51] || (_cache[51] = _createElementVNode("th", null, "전화번호", -1)),
                      _cache[52] || (_cache[52] = _createElementVNode("th", null, "연령대", -1)),
                      _cache[53] || (_cache[53] = _createElementVNode("th", null, "당신의 관심이 변화를 만듭니다.", -1)),
                      _cache[54] || (_cache[54] = _createElementVNode("th", null, "‘그들’이 아닌 ‘우리’의 문제입니다.", -1)),
                      _cache[55] || (_cache[55] = _createElementVNode("th", null, "존중과 인권을 이야기합니다.", -1)),
                      _cache[56] || (_cache[56] = _createElementVNode("th", null, "신청일", -1)),
                      ($setup.state.boardDetail.idx === $setup.state.eventIdx)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_28, "신청서"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    ($setup.state.totalLength > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.applyList, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.idx
                          }, [
                            _createElementVNode("td", null, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                            _createElementVNode("td", null, _toDisplayString(item.name), 1),
                            _createElementVNode("td", null, _toDisplayString(item.email), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString($setup.CommonUtils.convertPhoneNumReal(item.phoneNum)), 1)
                            ]),
                            _createElementVNode("td", null, [
                              (item.age === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "10대"))
                                : (item.age === 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "20대"))
                                  : (item.age === 3)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, "30대"))
                                    : (item.age === 4)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, "40대"))
                                      : (item.age === 5)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "50대"))
                                        : (item.age === 6)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, "60대"))
                                          : (item.age === 7)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, "70대 이상"))
                                            : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_37, [
                              _createElementVNode("label", {
                                for: 'chk_step1_0',
                                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: 'chk_step1_0',
                                  "onUpdate:modelValue": ($event: any) => ((item.step1) = $event),
                                  value: 0,
                                  disabled: ""
                                }, null, 8, _hoisted_38), [
                                  [_vModelCheckbox, item.step1]
                                ])
                              ]),
                              _createElementVNode("label", {
                                for: 'chk_step1_1',
                                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: 'chk_step1_1',
                                  "onUpdate:modelValue": ($event: any) => ((item.step1) = $event),
                                  value: 1,
                                  disabled: ""
                                }, null, 8, _hoisted_39), [
                                  [_vModelCheckbox, item.step1]
                                ])
                              ]),
                              _createElementVNode("label", {
                                for: 'chk_step1_2',
                                onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: 'chk_step1_2',
                                  "onUpdate:modelValue": ($event: any) => ((item.step1) = $event),
                                  value: 2,
                                  disabled: ""
                                }, null, 8, _hoisted_40), [
                                  [_vModelCheckbox, item.step1]
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_41, [
                              _createElementVNode("label", {
                                for: 'chk_step2_0',
                                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: 'chk_step2_0',
                                  "onUpdate:modelValue": ($event: any) => ((item.step2) = $event),
                                  value: 0,
                                  disabled: ""
                                }, null, 8, _hoisted_42), [
                                  [_vModelCheckbox, item.step2]
                                ])
                              ]),
                              _createElementVNode("label", {
                                for: 'chk_step2_1',
                                onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: 'chk_step2_1',
                                  "onUpdate:modelValue": ($event: any) => ((item.step2) = $event),
                                  value: 1,
                                  disabled: ""
                                }, null, 8, _hoisted_43), [
                                  [_vModelCheckbox, item.step2]
                                ])
                              ]),
                              _createElementVNode("label", {
                                for: 'chk_step2_2',
                                onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: 'chk_step2_2',
                                  "onUpdate:modelValue": ($event: any) => ((item.step2) = $event),
                                  value: 2,
                                  disabled: ""
                                }, null, 8, _hoisted_44), [
                                  [_vModelCheckbox, item.step2]
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_45, [
                              _createElementVNode("label", {
                                for: 'chk_step3_0',
                                onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: 'chk_step3_0',
                                  "onUpdate:modelValue": ($event: any) => ((item.step3) = $event),
                                  value: 0,
                                  disabled: ""
                                }, null, 8, _hoisted_46), [
                                  [_vModelCheckbox, item.step3]
                                ])
                              ]),
                              _createElementVNode("label", {
                                for: 'chk_step3_1',
                                onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: 'chk_step3_1',
                                  "onUpdate:modelValue": ($event: any) => ((item.step3) = $event),
                                  value: 1,
                                  disabled: ""
                                }, null, 8, _hoisted_47), [
                                  [_vModelCheckbox, item.step3]
                                ])
                              ]),
                              _createElementVNode("label", {
                                for: 'chk_step3_2',
                                onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: 'chk_step3_2',
                                  "onUpdate:modelValue": ($event: any) => ((item.step3) = $event),
                                  value: 2,
                                  disabled: ""
                                }, null, 8, _hoisted_48), [
                                  [_vModelCheckbox, item.step3]
                                ])
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date(item.createDate), ".")), 1),
                            ($setup.state.boardDetail.idx === $setup.state.eventIdx)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_49, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "table_btn _blue",
                                    onClick: ($event: any) => ($setup.showAnswer(item))
                                  }, "보기", 8, _hoisted_50)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("tr", _hoisted_51, [...(_cache[57] || (_cache[57] = [
                          _createElementVNode("td", { colspan: "6" }, [
                            _createElementVNode("div", {
                              class: "tb_subject",
                              style: {"text-align":"center","width":"100%"}
                            }, "신청 인원이 없습니다.")
                          ], -1)
                        ]))]))
                  ])
                ])
              ]),
              ($setup.state.totalLength > 0)
                ? (_openBlock(), _createBlock(_component_PageBtn, {
                    key: 0,
                    currentPage: $setup.state.page,
                    totalLength: $setup.state.totalLength,
                    perPage: $setup.state.size,
                    data: $setup.state.data,
                    onOnPaging: $setup.handlePageChange
                  }, null, 8, ["currentPage", "totalLength", "perPage", "data", "onOnPaging"]))
                : _createCommentVNode("", true)
            ])
          ])),
      _createElementVNode("div", null, [
        ($setup.state.eventIdx !== $setup.props.idx)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
              _createElementVNode("div", null, [
                _cache[58] || (_cache[58] = _createElementVNode("label", { for: "cntWin" }, "당첨인원", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "cntWin",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.state.boardDetail.cntWin) = $event))
                }, null, 512), [
                  [_vModelText, $setup.state.boardDetail.cntWin]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[59] || (_cache[59] = _createElementVNode("label", { for: "memo" }, "메모", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "memo",
                  class: "custom_scroll",
                  placeholder: "내용을 입력해주세요.",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.state.boardDetail.memo) = $event))
                }, null, 512), [
                  [_vModelText, $setup.state.boardDetail.memo]
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _createElementVNode("div", null, [
                _cache[66] || (_cache[66] = _createElementVNode("h1", null, "당신의 관심이 변화를 만듭니다.", -1)),
                _createElementVNode("p", _hoisted_54, [
                  _createElementVNode("label", {
                    onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[60] || (_cache[60] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[61] || (_cache[61] = _createTextVNode(" 외면도, 무관심도, 침묵도 성매매 카르텔입니다. ", -1))
                ]),
                _createElementVNode("p", _hoisted_55, [
                  _createElementVNode("label", {
                    onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[62] || (_cache[62] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[63] || (_cache[63] = _createTextVNode(" ANTI 성매매에 끊임없이 관심을 가집시다. ", -1))
                ]),
                _createElementVNode("p", _hoisted_56, [
                  _createElementVNode("label", {
                    onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[64] || (_cache[64] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[65] || (_cache[65] = _createTextVNode(" 성매매는 사회의 병적인 존재다. 이제는 변화해야 한다. 제발... ", -1))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[73] || (_cache[73] = _createElementVNode("h1", null, "‘그들’이 아닌 ‘우리’의 문제입니다.", -1)),
                _createElementVNode("p", _hoisted_57, [
                  _createElementVNode("label", {
                    onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[67] || (_cache[67] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[68] || (_cache[68] = _createTextVNode(" 성매매 문제는 남의 일이 아닙니다. 우리가 반드시 해결해야 하므로 함께 해 주십시오 ", -1))
                ]),
                _createElementVNode("p", _hoisted_58, [
                  _createElementVNode("label", {
                    onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[69] || (_cache[69] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[70] || (_cache[70] = _createTextVNode(" '그들'(성매매 여성)만의 문제가 아닌 '우리'(여성 그리고 모두)의 문제입니다. ", -1))
                ]),
                _createElementVNode("p", _hoisted_59, [
                  _createElementVNode("label", {
                    onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[71] || (_cache[71] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[72] || (_cache[72] = _createTextVNode(" 성매매는 '불법', 성구매자는 '전과자'입니다. ", -1))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[80] || (_cache[80] = _createElementVNode("h1", null, "존중과 인권을 이야기합니다.", -1)),
                _createElementVNode("p", _hoisted_60, [
                  _createElementVNode("label", {
                    onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[74] || (_cache[74] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[75] || (_cache[75] = _createTextVNode(" 성매매는 인권의 문제! 성매매라고 쓰고 성착취(성폭력)라고 읽는다. ", -1))
                ]),
                _createElementVNode("p", _hoisted_61, [
                  _createElementVNode("label", {
                    onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[76] || (_cache[76] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[77] || (_cache[77] = _createTextVNode(" 2차 피해만큼은 하지 마십시오. 당신도 똑같은 가해자입니다. ", -1))
                ]),
                _createElementVNode("p", _hoisted_62, [
                  _createElementVNode("label", {
                    onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
                  }, [...(_cache[78] || (_cache[78] = [
                    _createElementVNode("input", {
                      type: "checkbox",
                      disabled: ""
                    }, null, -1)
                  ]))]),
                  _cache[79] || (_cache[79] = _createTextVNode(" 성매매 없는 사회, 인간의 존중과 가치를 보여주세요. ", -1))
                ])
              ])
            ]))
      ]),
      ($setup.state.eventIdx !== $setup.props.idx)
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _createElementVNode("button", {
              class: "submit_btn _130 _main_blue",
              onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.save()))
            }, "저장")
          ]))
        : _createCommentVNode("", true)
    ]),
    ($setup.state.isShowAnswer)
      ? (_openBlock(), _createBlock(_component_SpotTheDiff, {
          key: 0,
          answerInfo: $setup.state.answerInfo,
          onClose: _cache[25] || (_cache[25] = ($event: any) => ($setup.state.isShowAnswer = false)),
          onCallback: _cache[26] || (_cache[26] = ($event: any) => {
            $setup.state.isShowAnswer = false;
            $setup.getApplyList();
        })
        }, null, 8, ["answerInfo"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[27] || (_cache[27] = ($event: any) => ($setup.state.isShowModal = false))
        }, null, 8, ["type", "title", "content"]))
      : _createCommentVNode("", true)
  ], 64))
}